import { render, staticRenderFns } from "./Friends.vue?vue&type=template&id=2cfdf76f&scoped=true&"
import script from "./Friends.vue?vue&type=script&lang=js&"
export * from "./Friends.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=2cfdf76f&prod&scoped=true&lang=css&"
import style1 from "./Friends.vue?vue&type=style&index=1&id=2cfdf76f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfdf76f",
  null
  
)

export default component.exports